import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import PageHeader from './PageHeader';
// 

export default function Contact(){
    return (
        <>
        <PageHeader title="Contact Us" />

<div className="container-fluid row mt-3 p-5">
    <div className="col-lg-1"></div>
    <div className="col-1 text-end">
        <div className='bodyTextNP'>
        <a href="tel:15619226400"><FontAwesomeIcon icon={faPhone} size="xl" style={{color: "#0275d8",}} /></a> <br/> <br/>
        <a href="mailto:sanjay@ft-consultants.com?subject=Website Contact Inquiry - F&T Consulting">
            <FontAwesomeIcon icon={faEnvelope} size="xl" style={{color: "#0275d8",}} />
        </a><br/> <br/>
        <a href="https://goo.gl/maps/xumQWMUk3ZkT7aet8" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faLocationDot} size="xl" style={{color: "#0275d8",}} /> 
        </a><br/> <br/>
        </div>
    </div>
    <div className="col ps-3">
        <div className='bodyTextNP'>
            +1(561)922-6400<br /> <br />

            sanjay@ft-consultants.com<br /> <br />

            Finance & Technology Consultants, Inc <br />
            9100 Beleveder Road,<br />
            Suite 205, 2nd Floor,<br />
            Royal Palm Beach, FL, 33411<br />
        </div>
    </div>
    <div className="col-lg mt-3">
        <iframe title="Map" className='w-100' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3564.66825510926!2d-80.19535498826721!3d26.6910904694814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d92f2a1ed0c9a5%3A0x19a903fdf32db99!2s9100%20Belvedere%20Rd%20Suite%20205%2C%202nd%20Floor%2C%20West%20Palm%20Beach%2C%20FL%2033411!5e0!3m2!1sen!2sus!4v1687444840833!5m2!1sen!2sus" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    <div className="col-lg-1"></div>

</div>
        </>
    );
};